import { Col, Row } from 'reactstrap';
import { PeriodPresenter } from 'Common';

export const SubscriptionDetailCourseAttendance = ({ courseAttendance }) => {
  return (
    <>
      <Row className="mt-2">
        <Col xs={12} sm={6} className="subscription-status-title">
          <strong>Freischaltung</strong>
        </Col>
        <Col xs={12} sm={6}>
          {courseAttendance.courseTeaser.title}
        </Col>
      </Row>
      <Row className="mt-2">
        <Col xs={12} sm={6} className="subscription-status-title">
          <strong>Laufzeit aktuelle Periode</strong>
        </Col>
        <Col xs={12} sm={6}>
          <PeriodPresenter start={courseAttendance.startedAt} end={courseAttendance.endsAt} />
        </Col>
      </Row>
    </>
  );
};
